import React, { useEffect, useState } from "react";

import {
    Delete as DeleteIcon,
    Edit as EditIcon,
    Add as AddIcon,
    Image,
    DynamicFeed,
    LocalOffer as SeoIcon,

} from "@material-ui/icons";
import { DefaultTable } from "../../../components/data-table";
import FormModalContent from "./form";
import ConfirmModalContent from "../../../components/confirm-modal-content";
import glassesService from "../../../services/glasses.service";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import GlassesColorsPage from "../glasses-colors";
import PaletteIcon from "@material-ui/icons/Palette";
import LibraryAddOutlinedIcon from "@material-ui/icons/LibraryAddOutlined";
import InventoryChangeModalContent from "./inventory";
import GlassGalleryForm from "./glassGallery/glassGalleryForm";
import brandsService from "../../../services/brands.service";
import SearchKeyFormModal from "./searchKeyForm";
import SeoFormModalContent from "./seo_form";

const defaultKeys = [
    {
        title: "نام",
        field: "name",
        active: true,
    },
];

export default function GlassesPage() {
    const { initials } = useSelector((state) => state.app);

    const [data, setData] = useState([]);
    const [brands, setBrands] = useState([]);
    const [loading, setLoading] = useState(true);
    const [headersState, setHeaderState] = useState([]);
    const [extra, setExtra] = useState(null);
    const [filters, setFilters] = useState({
        page: 1,
        perpage: 20,
        search: '',
        brandIds: null
    })

    const deleteItem = (item) => {
        return glassesService.deleteGlasses(item.id);
    };

    const headerCells = useMemo(
        () => {
            const head = [
                {
                    field: "name",
                    title: "نام",
                    mainField: true,
                },
                {
                    field: "brandId",
                    title: "برند",
                    disableSort: true,
                    renderer: (val, fullData, extra) => {
                        return fullData?.brand?.name || "";
                    }
                },
                {
                    field: "category",
                    title: "نوع",
                    renderer: (val) =>
                        initials?.enums?.glassCategory?.find((i) => i.value === val)?.title ||
                        "",
                },
                {
                    field: "colors",
                    title: "رنگ‌ها",
                    disableSort: true,
                    renderer: (val) => val.map((c) => `${c.name}`).join(", "),
                },

                {
                    field: "gender",
                    title: "جنسیت",
                    disableSort: true,
                    renderer: (val) =>
                        initials?.enums?.gender?.find((i) => i.value === val)?.title || "",
                },
                {
                    field: "material",
                    title: "جنس",
                    disableSort: true,
                    renderer: (val) =>
                        initials?.enums?.material?.find((i) => i.value === val)?.title || "",
                },
                {
                    field: "lensMaterial",
                    title: "جنس لنز",
                    disableSort: true,
                    renderer: (val) =>
                        initials?.enums?.lensMaterial?.find((i) => i.value === val)?.title ||
                        "",
                },
                {
                    field: "isActive",
                    title: "وضعیت",
                    // disableSort: true,
                    renderer: (val) => (val ? "فعال" : "غیر فعال"),
                },
                {
                    field: "shape",
                    title: "شکل",
                    disableSort: true,
                    renderer: (val) =>
                        initials?.enums?.shape?.find((i) => i.value === val)?.title || "",
                },
                // {
                //   field: "size",
                //   title: "سایز",
                //   // disableSort: true,
                //   renderer: (val) =>
                //     initials?.enums?.size?.find((i) => i.value === val)?.title || "",
                // },
                {
                    field: "weight",
                    title: "وزن",
                },
                {
                    field: "createDate",
                    title: "تاریخ",
                    date: true,
                },
            ].map(col => {
                col.hidden = headersState.find(it => it.field === col.field)?.hidden ?? false
                return col;
            });

            return head
        },
        [initials, headersState]
    );

    const filterForm = useMemo(
        () => {
            return !extra?.brands
            ? undefined
            : {
                handleSubmit: (item) => {
                    setFilters(prev => {
                        const brandIds = item.brandIds ? [item.brandIds] : null
                        return {
                            ...prev,
                            brandIds,
                            page: 1
                        }
                    })
                },
                form: [
                    {
                        _type: "autocomplete",
                        _empty: "",
                        name: "brandIds",
                        options: extra.brands.map(item => ({ ...item, value: item.id, title: item.name })),
                        valueSelector: "value",
                        labelSelector: "title",
                        label: "برندها",
                        disableClearable: false,
                    },
                ],
            }
        },
        [extra?.brands]
    );

    const onRefresh = async () => {
        setLoading(true);

        let query = [
            `page=${filters.page}`,
            `perpage=${filters.perpage}`,
            `search=${filters.search}`,
        ];
        if (filters.brandIds) {
            query.push(`brandIds[]=${filters.brandIds}`);
        }

        const { data, error } = await glassesService.getGlasses(query);
        setLoading(false)

        if (error) {
            return;
        }
        setData(data);

        if(!extra){
            setExtra(data.extra)
        }
    };

    useEffect(() => {
        onRefresh();
    }, [filters])

    return (
        <div className="p-3">
            <DefaultTable
                headCells={headerCells}
                headCellsChange={setHeaderState}
                rows={data?.items ?? []}
                totalRows={data.totalItems}
                loading={loading}
                page={filters.page}
                rowsPerPage={filters.perpage}

                setPage={page => setFilters(prev => ({ ...prev, page }))}
                setSearchText={search => setFilters(prev => ({ ...prev, search, page: 1 }))}

                onRefresh={onRefresh}

                filterForm={filterForm}
                rowActions={[
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <SeoIcon />,
                        modalContent: (props) => <SeoFormModalContent {...props} />,
                    },
                    {
                        icon: <PaletteIcon />,
                        modalProps: { fullScreen: true },
                        refreshOnClose: false,
                        modalContent: (props) => <GlassesColorsPage {...props} extra={extra} onRefresh={onRefresh} />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <LibraryAddOutlinedIcon />,
                        hidden: (data) =>
                            !data.colors.length || !data.colors.find((c) => c.sizes.length),
                        modalContent: (props) => <InventoryChangeModalContent {...props} extra={extra} />,
                    },
                    {
                        modalProps: { maxWidth: "md" },
                        icon: <EditIcon />,
                        modalContent: (props) => {
                            return <FormModalContent {...props} extra={extra} />
                        },
                    },
                    {
                        modalProps: { maxWidth: "md" },
                        icon: <DynamicFeed />,
                        modalContent: (props) => {
                            return <SearchKeyFormModal {...props} extra={extra} />
                        },
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <Image />,
                        modalContent: (props) => <GlassGalleryForm {...props} />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <DeleteIcon />,
                        modalContent: (props) => (
                            <ConfirmModalContent
                                onConfirm={() => deleteItem(props.data)}
                                confirmText={props.data.name}
                                close={props.close}
                            />
                        ),
                    },
                ]}
                actions={[
                    {
                        modalProps: { maxWidth: "md" },
                        icon: <AddIcon />,
                        tooltip: "ایجاد عینک",
                        modalContent: (props) => {
                            return <FormModalContent {...props} extra={extra} onRefresh={onRefresh} />;
                        },
                    },
                ]}
                searchKeys={defaultKeys}
                title="عینک‌ها"
                sort={{ order: "DESC", orderBy: "createDate" }}
            />
        </div>
    );
}